import { useFormContext } from "react-hook-form";
import usePermissions from "hooks/usePermissions";

export default function useGetMultiDrop() {
  const { watch } = useFormContext();
  const { permissions } = usePermissions();
  const permissionsParsed = JSON.parse(permissions || "{}");
  const can_create_multidrop_quote_requests =
    permissionsParsed.company_shipper_settings?.can_create_multidrop_quote_requests;

  const invited_modes = watch("invited_modes") || {};
  const isMultiDropFreightModeSelected = invited_modes?.road_freight && invited_modes?.road_freight_option === "multi-drop";

  const isMultiDropQuoteRequest = can_create_multidrop_quote_requests && isMultiDropFreightModeSelected;

  return { isMultiDropQuoteRequest };
}
